import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=669b3c9c"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import "./BarChart.vue?vue&type=style&index=0&id=669b3c9c&prod&lang=css"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports